import { useSyncExternalStore } from 'react';

/**
 * Whether a media query matches, kept current as the viewport changes.
 *
 * For behaviour that CSS cannot express — which edge a sheet opens from — not
 * for layout, which stays in CSS. The only queries Fidelen uses are its two
 * existing boundaries, 640px and 1024px (R-050 addendum BREAKPOINTS: no third).
 * Where `matchMedia` does not exist (a test environment), nothing matches.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (typeof window.matchMedia !== 'function') return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener('change', notify);

      return () => list.removeEventListener('change', notify);
    },
    () => (typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false),
    () => false,
  );
}

/** Below the 640px boundary: the phone tier. */
export const PHONE_QUERY = '(max-width: 639.98px)';
